import AppHeader from "../../layout/AppHeader";
import External from '../../xpost/views/register/external/External.vue';
import ExternalAdd from '../../xpost/views/register/external/ExternalAdd.vue';

const ExternalRoutes = [
    {
        path: "/cadastro/terceiro",
        name: "external",
        components: {
            header: AppHeader,
            default: External
        }
    },
    {
        path: "/cadastro/terceiro/adicionar",
        name: "external.add",
        components: {
            header: AppHeader,
            default: ExternalAdd
        }
    },
    {
        path: '/cadastro/terceiro/editar/:id',
        name: 'external.edit',
        components: {
            header: AppHeader,
            default: ExternalAdd
        }
    }
]

export default ExternalRoutes;